import React, { useRef, useEffect, useState } from "react";
import { FileUpload } from "primereact/fileupload";
import { Button } from "primereact/button";
import AtkButton from "../AtlaskitControls/AtkButton";
import AtkLoader from "../AtlaskitControls/AtkLoader";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";

export default function UploadDocumentStep(props: any) {
  const fileUploadRef = useRef<FileUpload>(null);

  useEffect(() => {
    if (props.selectedFile && fileUploadRef.current) {
      fileUploadRef.current.setFiles([props.selectedFile]);
    }
  }, [props.selectedFile]);

  return (
    <div className="card border-0">
      <div className=" border-bottom pb-3 px-4 pt-4">
        <h6 className="mb-1">Upload Documents</h6>

        <p className="text-muted mb-0 text-12">Upload policy declaration page</p>
      </div>

      <div className="card-body pt-4 px-4">
        <div className="mb-3">
          <div className={`col-lg-3 col-md-5 col-sm-12 col-12 my-2 ${props.documentTypeError.length > 0 ? " validation-div " : " "}`}>
            <label className="form-label fw-medium text-14">
              Line of business<span className="text-danger"> *</span>
            </label>{" "}
            <Dropdown
              type="text"
              value={props.documentType}
              options={props.allDocumentType}
              onChange={(e: any) => props.onDocumentTypeChage(e)}
              placeholder="Select line of business"
              className="finance-company-dropdown input-field"
            />
             <span className="text-12 text-danger">{props.documentTypeError}</span>
          </div>
          
          {props.fileURL != null && props.fileURL != "" ? (
            <div className="d-flex justify-content-between mb-2">
              <span className="text-purple">{props.fileName}</span>
              {props.viewDocumentLoading ? (
                <AtkLoader />
              ) : (
                <AtkButton label="View Uploaded File" onClick={props.onViewDocumentClicked} className="w-auto pf-primary-btn" />
              )}
            </div>
          ) : null}
          <Dialog
            visible={props.showDocument}
            style={{ width: "60vw" }}
            onHide={props.onCloseDocumentDialogClick}
            draggable={false}
            className="infoDialog"
          >
            <iframe src={props.uploadedDocumentUrl} title="PDF Viewer" width="100%" height="600px" />
          </Dialog>
          <div className="rounded-3 p-4 text-center " style={{ border: "2px dashed #e2e8f0" }}>
            <FileUpload
              ref={fileUploadRef}
              id="file-upload"
              name="policyDeclaration"
              customUpload
              auto
              chooseLabel="Browse Files"
              className="mt-3"
              accept=".pdf,.jpg,.jpeg,.png"
              maxFileSize={10000000}
              onSelect={props.onFileSelected}
              onRemove={props.onFileSelected}
              emptyTemplate={
                <>
                  <i className="fa fa-upload text-secondary" style={{ fontSize: "2rem" }}></i>
                  <p className="text-muted small mt-2 mb-1">Drag and drop your file here, or click to browse</p>
                  <p className="text-muted small">(Supports PDF, JPG, PNG – Max 10MB)</p>
                </>
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
}
